import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, ClipboardListIcon } from 'lucide-react';
import { site } from '../data/site';
export function MobileCallBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-ink-700 bg-ink lg:hidden" data-id="element-215" data-mp="2ed5615rilfl3">
      <a href={site.estimatePhone.href} className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-wide text-white" data-id="element-216" data-mp="2idxf9z0dzkhd">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-217" data-mp="24l8y72zmmb3o" />
        Call {site.estimatePhone.display}
      </a>
      <Link to="/contact" className="flex items-center justify-center gap-2 bg-safety py-4 text-sm font-bold uppercase tracking-wide text-white" data-id="element-218" data-mp="1up5uhsp4m4em">
        <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-219" data-mp="1zlwakg0xl001" />
        Free Estimate
      </Link>
    </div>;
}